/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import {
   Link,
   Grid,
   Typography }                     from '@material-ui/core'

import { CLIENT_PUBLIC_TOKEN }      from '../config'

import { node_server }              from '../Helpers'

const HistoryCitationReadComponent = () => {

   const [ citations,   setCitations   ]  =  useState([])

   useEffect( () => {
console.log('HistoryCitationComponent useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'historyCitation')
      .then( res => res.data )
      .then( data => {
         let text
         setCitations(data.entry.map( c => {
            if ( c.link === '' ) {
               text = 
                  <Typography key={c._id} align='left' >
                     [ { c.citation_number } ] {c.citation}
                  </Typography>  

            }
            else {
               text =
                  <Link key={c._id} href={c.link} target="_blank" rel="noopener noreferrer" >
                     <Typography key={c._id} align='left' >
                        [ { c.citation_number } ] {c.citation}
                     </Typography>
                  </Link>
            }
            return( text )
         }))
      })
      .catch( (error) => {
         console.error(error)
      })

   }, [])

   return (
      <Box >
         <Grid style={{ padding: '2rem' }} >
            { citations }
         </Grid>
      </Box>
   )
}

export default HistoryCitationReadComponent
